import { z } from "zod";
import { selectArticlesSchema } from "./select-articles.schema";

export const orderTemplateFormSchema = z
	.object({
		name: z.string().min(1, "Name is required"),
		scope: z.enum(["user", "global"]).default("global"),
	})
	.and(selectArticlesSchema);

export type OrderTemplateFormSchema = z.infer<typeof orderTemplateFormSchema>;
